import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import PropTypes from 'prop-types';

import { getLink } from '../../../../helpers/rotate-links';

const Tracker = ({ pageContext }) => {
  const redirect = () => {
    if (typeof window !== 'undefined') {
      window.location.href = getLink(pageContext.provider, localStorage.getItem('pageTemplate'));
    }
  };
  redirect();
  return <></>;
};

Tracker.propTypes = {
  pageContext: PropTypes.shape({
    pageType: PropTypes.string,
    provider: PropTypes.shape({
      links: PropTypes.shape({
        static: PropTypes.shape({}),
        campaigns: PropTypes.shape({}),
      }),
      name: PropTypes.string,
    }),
  }),
};

export default Tracker;
